module.exports = {
  DEV: 'dev',
  QA: 'qa',
  PREPROD: 'preprod',
  TESTNET: 'testnet',
  PRODUCTION: 'production',
  CN: 'cn',
  GLOBAL: 'global',
};

// preference keys
module.exports.SETTING_KEYS = {
  LANGUAGE: 'language',
  CURRENCY: 'nativeCurrency',
};
